export const HISTORY_ACCESS_REASONS = [
  'PARTICIPATION',
  'LABORAL_SUPERVISION',
] as const;

export type HistoryAccessReason = (typeof HISTORY_ACCESS_REASONS)[number];

export function isValidHistoryAccessReasons(
  accessReasons: readonly HistoryAccessReason[],
  allowEmpty = false,
): boolean {
  if (!allowEmpty && accessReasons.length === 0) {
    return false;
  }

  const seen = new Set<HistoryAccessReason>();
  return accessReasons.every((reason) => {
    if (seen.has(reason)) {
      return false;
    }
    seen.add(reason);
    return true;
  });
}

export function getHistoryAccessLabel(accessReasons: readonly HistoryAccessReason[]): string {
  const hasParticipation = accessReasons.includes('PARTICIPATION');
  const hasLaboralSupervision = accessReasons.includes('LABORAL_SUPERVISION');

  if (hasParticipation && hasLaboralSupervision) {
    return 'Participación y supervisión';
  }
  if (hasParticipation) {
    return 'Participación';
  }
  if (hasLaboralSupervision) {
    return 'Supervisión Laboral';
  }
  return '-';
}
